export const SubtitlesPositionType = {
  DOWN: 'Down',
  UP: 'Up'
}

export const SubtitlesFontSizeType = {
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
}